import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Card,
  Typography,
  List,
  ListItem,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Tooltip,
  Chip,
} from "@mui/material";
import {
  useGetEmployeeScheduleDetailsByDateQuery,
  useGetPunchDashboardQuery,
  useGetTeamQuery,
  useGetUserInfoOnyQuery,
} from "../../../Api/attoDeskApi";
import {
  IScheduleListDetails,
  ITeam,
  IUserAdmin,
  PunchDetails,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { Privileges } from "../../../Core/Enum/enum";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import EmpImg from "../Component/EmpImg";
import AdminEdit from "../AdminEdit/index";
import useUser from "../../../Core/hook/useUser";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import NorthIcon from "@mui/icons-material/North";
import SouthIcon from "@mui/icons-material/South";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import AdminPunchInEdit from "../AdminEdit/editPunchInTime";
import AdminPunchOutEdit from "../AdminEdit/editPunchOutTime";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import { CiEdit } from "react-icons/ci";
import LogoMain from "../../../Images/logo.webp";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100000);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const { userHasRight } = useUser();
  const [searchParams] = useSearchParams();
  const selectedDateAttandanceList = searchParams.get("date");

  const [selectedCoursing, setSelectedCoursing] =
    useState<IScheduleListDetails | null>(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [selectedAdminEdit, setSelectedAdminEdit] =
    useState<IScheduleListDetails | null>(null);
  const [openDialogAdminEdit, setOpenDialogAdminEdit] = useState(false);

  const [selectedAdminEditPunchIn, setSelectedAdminEditPunchIn] =
    useState<PunchDetails | null>(null);
  const [openDialogAdminEditPunchIn, setOpenDialogAdminEditPunchIn] =
    useState(false);

  const [selectedAdminEditPunchOut, setSelectedAdminEditPunchOut] =
    useState<PunchDetails | null>(null);
  const [openDialogAdminEditPunchOut, setOpenDialogAdminEditPunchOut] =
    useState(false);

  const [selectedImg, setSelectedImg] = useState<IScheduleListDetails | null>(
    null
  );
  const [openDialogImg, setOpenDialogImg] = useState(false);
  const [selectedIsBooked, setSelectedProductIsBooked] = useState<string>("");
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(dayjs());

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const selectedDateAttandanceList = searchParams.get("date");
    if (selectedDateAttandanceList) {
      const parsedDate = dayjs(selectedDateAttandanceList, "YYYY-MM-DD", true); // Parse the date with strict mode
      if (parsedDate.isValid()) {
        setSelectedDate(parsedDate);
        setPaymentMonthYear(dayjs(parsedDate));
      }
    }
  }, [searchParams]);

  const { data, isLoading, isError, refetch } =
    useGetEmployeeScheduleDetailsByDateQuery({
      date: paymentMonthYear.format("YYYY-MM-DD"),
    });

  const handleIsBooked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setPaymentMonthYear(dayjs(selectedValue));
  };

  const { data: tenantData, isLoading: tenantIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: dashboardData, isLoading: dashboardIsLoading } =
    useGetPunchDashboardQuery();

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const teamList = useMemo(() => {
    return tenantData?.data as ITeam[];
  }, [tenantData?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((user) => {
      map.set(user.id, `${user.user_role_name} - ${user.username}`);
    });
    return map;
  }, [userList]);

  const teamMap = useMemo(() => {
    const map = new Map<number, { name: string; image: string }>(); // Map to hold id as key and an object with name and image as value
    teamList?.forEach((teamMember) => {
      const fullName = `${toProperCase(
        teamMember.teamFirstName || ""
      )} ${toProperCase(teamMember?.teamLastName || "")}`;
      map.set(teamMember.id, { name: fullName, image: teamMember.teamImg });
    });
    return map;
  }, [teamList]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleOpenDialogAdminEdit = (coursing: IScheduleListDetails) => {
    setSelectedAdminEdit(coursing);
    setOpenDialogAdminEdit(true);
  };

  const handleOpenDialogAdminEditPunchIn = (coursing: PunchDetails) => {
    setSelectedAdminEditPunchIn(coursing);
    setOpenDialogAdminEditPunchIn(true);
  };

  const handleOpenDialogAdminEditPunchOut = (coursing: PunchDetails) => {
    setSelectedAdminEditPunchOut(coursing);
    setOpenDialogAdminEditPunchOut(true);
  };

  const handleCloseDialogAdminEdit = () => {
    setSelectedAdminEdit(null);
    setOpenDialogAdminEdit(false);
  };

  const handleCloseDialogAdminEditPunchIn = () => {
    setSelectedAdminEditPunchIn(null);
    setOpenDialogAdminEditPunchIn(false);
  };

  const handleCloseDialogAdminEditPunchOut = () => {
    setSelectedAdminEditPunchOut(null);
    setOpenDialogAdminEditPunchOut(false);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };
  const handleCloseDialogImg = () => {
    setSelectedImg(null);
    setOpenDialogImg(false);
  };

  const handleDateChange = (newValue: Dayjs | null) => {
    setSelectedDate(newValue);

    if (newValue) {
      const mockEvent = {
        target: {
          value: newValue.format("YYYY-MM-DD"),
        },
      } as React.ChangeEvent<HTMLInputElement>;

      handleIsBooked(mockEvent);
    }
  };

  const handleCloseDialogGenerate = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    setOpen(false);
    navigate("/payroll/generate");
  };

  const goToPreviousDay = () => {
    const prevDay =
      selectedDate?.subtract(1, "day") || dayjs().subtract(1, "day");
    handleDateChange(prevDay);
  };

  const goToNextDay = () => {
    const nextDay = selectedDate?.add(1, "day") || dayjs().add(1, "day");
    handleDateChange(nextDay);
  };

  const coursings: IScheduleListDetails[] = Array.isArray(data?.data)
    ? (data?.data as IScheduleListDetails[])
    : [];

  const handleAddProductClick = () => {
    navigate(
      `/attendance/create?date=${paymentMonthYear.format("YYYY-MM-DD")}`
    );
  };

  const handleExportToExcel = () => {
    // const tableData = coursings.map((row, index) => ({
    //   "#": index + 1,
    //   Name: teamMap.get(row.empid)?.name || "",
    //   Schedule: `${formatTime(row.schedule?.startTime) || " "} - ${
    //     formatTime(row.schedule?.endTime) || " "
    //   }`,
    //   "Clocked Hours": row.workStartTime?.actual_punched_time
    //     ? `${formatTime(row.workStartTime.actual_punched_time)} - ${
    //         row.finishWorkTime?.actual_punched_time
    //           ? formatTime(row.finishWorkTime.actual_punched_time)
    //           : "Pending"
    //       }`
    //     : " ",
    //   "Punch In": formatTime(row.workStartTime?.punched_time) || "Pending",
    //   // "Punch Out": formatTime(row.finishWorkTime?.punched_time) || "Pending",
    //   "Punch Out": row.finishWorkTime?.punched_time
    //     ? row.workStartTime?.punched_date !== row.finishWorkTime.punched_date
    //       ? `${dayjs(row.finishWorkTime.punched_date).format(
    //           "MMM-DD, YYYY"
    //         )} ${formatTime(row.finishWorkTime.punched_time)}`
    //       : formatTime(row.finishWorkTime.punched_time)
    //     : "Pending",
    // }));
    const tableData = coursings.map((row, index) => {
      const start = formatTime(row.schedule?.startTime) || " ";
      const end = formatTime(row.schedule?.endTime) || " ";
      const spansNextDay = row.schedule?.spansNextDay ? " [next day]" : "";

      const scheduleText = `${start} - ${end}${spansNextDay}`;

      return {
        "#": index + 1,
        Name: teamMap.get(row.empid)?.name || "",
        Schedule: scheduleText,
        "Clocked Hours": row.workStartTime?.actual_punched_time
          ? `${formatTime(row.workStartTime.actual_punched_time)} - ${
              row.finishWorkTime?.actual_punched_time
                ? formatTime(row.finishWorkTime.actual_punched_time)
                : "Pending"
            }`
          : " ",
        "Punch In": formatTime(row.workStartTime?.punched_time) || "Pending",
        "Punch Out": row.finishWorkTime?.punched_time
          ? row.workStartTime?.punched_date !== row.finishWorkTime.punched_date
            ? `${dayjs(row.finishWorkTime.punched_date).format(
                "MMM-DD, YYYY"
              )} ${formatTime(row.finishWorkTime.punched_time)}`
            : formatTime(row.finishWorkTime.punched_time)
          : "Pending",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const formattedDate = selectedDate?.format("MMM-DD, YYYY");
    const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, "ClockIn/OutList");
    XLSX.utils.book_append_sheet(workbook, worksheet, "ClockInOutList");
    const fileName = `ClockInOutList_${formattedDate}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleExportToPDF = () => {
    // const tableData = coursings.map((row, index) => [
    //   index + 1,
    //   teamMap.get(row.empid)?.name || "",
    //   `${formatTime(row.schedule?.startTime) || " "} - ${
    //     formatTime(row.schedule?.endTime) || " "
    //   }`,
    //   row.workStartTime?.actual_punched_time
    //     ? `${formatTime(row.workStartTime.actual_punched_time)} - ${
    //         row.finishWorkTime?.actual_punched_time
    //           ? formatTime(row.finishWorkTime.actual_punched_time)
    //           : "Pending"
    //       }`
    //     : " ",
    //   formatTime(row.workStartTime?.punched_time) || "Pending",
    //   // formatTime(row.finishWorkTime?.punched_time) || "Pending",
    //   row.finishWorkTime?.punched_time
    //     ? row.workStartTime?.punched_date !== row.finishWorkTime.punched_date
    //       ? `${dayjs(row.finishWorkTime.punched_date).format(
    //           "MMM-DD, YYYY"
    //         )} ${formatTime(row.finishWorkTime.punched_time)}`
    //       : formatTime(row.finishWorkTime.punched_time)
    //     : "Pending",
    // ]);
    const tableData = coursings.map((row, index) => {
      const start = formatTime(row.schedule?.startTime) || " ";
      const end = formatTime(row.schedule?.endTime) || " ";
      const spansNextDay = row.schedule?.spansNextDay ? " [next day]" : "";

      const scheduleText = `${start} - ${end}${spansNextDay}`;

      return [
        index + 1,
        teamMap.get(row.empid)?.name || "",
        scheduleText,
        row.workStartTime?.actual_punched_time
          ? `${formatTime(row.workStartTime.actual_punched_time)} - ${
              row.finishWorkTime?.actual_punched_time
                ? formatTime(row.finishWorkTime.actual_punched_time)
                : "Pending"
            }`
          : " ",
        formatTime(row.workStartTime?.punched_time) || "Pending",
        row.finishWorkTime?.punched_time
          ? row.workStartTime?.punched_date !== row.finishWorkTime.punched_date
            ? `${dayjs(row.finishWorkTime.punched_date).format(
                "MMM-DD, YYYY"
              )} ${formatTime(row.finishWorkTime.punched_time)}`
            : formatTime(row.finishWorkTime.punched_time)
          : "Pending",
      ];
    });

    const tableHeaders = [
      ["#", "Name", "Schedule", "Clocked Hours", "Punch In", "Punch Out"],
    ];

    const currentMonth = dayjs().format("YYYY MMM, DD");

    const doc = new jsPDF("l", "mm", "a4");
    const formattedDate = selectedDate?.format("MMM-DD, YYYY");

    const imageUrl = LogoMain;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = 50;
    const imgHeight = 12;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 15;

    const img = new Image();
    img.src = imageUrl;
    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Clock In/Out List`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Date: ${formattedDate}`, textStartY + 5);

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `ClockIn/OutList_${formattedDate}.pdf`;

      doc.save(fileName);
    };
  };

  if (userIsLoading || dashboardIsLoading || tenantIsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Card
              className={classes.cardPrimary}
              sx={{
                padding: 2,
                height: "100%",
              }}
            >
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Typography className={classes.dashboardTypograpy}>
                    Clock In
                  </Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    {dashboardData?.data.total_punch_in}
                  </Typography>
                </Grid>

                <Grid item>
                  <Box className={classes.dashboardPrimary}>
                    <SouthIcon sx={{ fontSize: 40 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Card
              className={classes.cardPrimary}
              sx={{
                padding: 2,
                height: "100%",
              }}
            >
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Typography className={classes.dashboardTypograpy}>
                    Clock Out
                  </Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    {dashboardData?.data.total_punch_out}
                  </Typography>
                </Grid>

                <Grid item>
                  <Box className={classes.dashboardPrimary}>
                    <NorthIcon sx={{ fontSize: 40 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Card
              className={classes.cardPrimary}
              sx={{
                padding: 2,
                height: "100%",
              }}
            >
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Typography className={classes.dashboardTypograpy}>
                    Employees
                  </Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    {dashboardData?.data.active_employees}
                  </Typography>
                </Grid>

                <Grid item>
                  <Box className={classes.dashboardPrimary}>
                    <Groups2OutlinedIcon sx={{ fontSize: 40 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Card
              className={classes.cardPrimary}
              sx={{
                padding: 2,
                height: "100%",
              }}
            >
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Typography className={classes.dashboardTypograpy}>
                    Active
                  </Typography>
                  <Typography className={classes.buttonLabelForHeading}>
                    {dashboardData?.data.status_counts?.[1] ?? 0}
                  </Typography>
                </Grid>

                <Grid item>
                  <Box className={classes.dashboardPrimary}>
                    <CheckCircleOutlinedIcon sx={{ fontSize: 40 }} />
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card className={classes.card}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            {/* <Grid
              item
              lg={4}
              md={4}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-start" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-start"
                sx={{ display: "flex" }}
              >
                <Grid item lg={3} md={3}>
                  <Button
                    variant="contained"
                    className={classes.addNewButton}
                    onClick={handleAddProductClick}
                  >
                    Add New
                  </Button>
                </Grid>
              </Grid>
            </Grid> */}
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{
                  display: "flex",
                  justifyContent: {
                    xs: "flex-start",
                    md: "flex-end",
                  },
                }}
              >
                <Grid item>
                  <List className={classes.ListPayroll}>
                    <ListItem className={classes.ListItemPayroll}>
                      <IconButton
                        color="primary"
                        onClick={goToPreviousDay}
                        aria-label="Previous Day"
                      >
                        <KeyboardArrowLeftIcon />
                      </IconButton>
                    </ListItem>
                    <ListItem className={classes.ListItemPayroll}>
                      <Button
                        className={classes.ListItemPayrollToday}
                        // onClick={goToToday}
                        aria-label="Today"
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={selectedDate}
                            onChange={handleDateChange}
                            slotProps={{
                              textField: {
                                placeholder: "Date of Birth",
                                size: "small",
                                sx: {
                                  width: "140px",
                                },
                                InputProps: {
                                  sx: {
                                    fontSize: 14,
                                    color: "#97c3df",
                                  },
                                  // classes: {
                                  //   // root: classes.textFieldQuote,
                                  // },
                                  classes: {
                                    root: classes.formControlListStatus,
                                    notchedOutline: classes.notchedOutline,
                                  },
                                },
                                InputLabelProps: {
                                  sx: {
                                    fontSize: 14,
                                    color: "#97c3df",
                                  },
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Button>
                    </ListItem>
                    <ListItem className={classes.ListItemPayroll}>
                      <IconButton
                        color="primary"
                        onClick={goToNextDay}
                        aria-label="Next Day"
                      >
                        <KeyboardArrowRightIcon />
                      </IconButton>
                    </ListItem>
                  </List>
                </Grid>
                <Grid item>
                  <Button
                    // variant="contained"
                    startIcon={<TableViewIcon />}
                    className={classes.addButtonPdfExcel}
                    onClick={handleExportToExcel}
                  >
                    Excel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    // variant="contained"
                    startIcon={<LocalPrintshopSharpIcon />}
                    className={classes.addButtonPdfExcel}
                    onClick={handleExportToPDF}
                  >
                    pdf
                  </Button>
                </Grid>
                <Grid item>
                  <Link
                    to={`/attendance/create?date=${paymentMonthYear.format(
                      "YYYY-MM-DD"
                    )}`}
                    className={classes.iconLinkPropNormal}
                  >
                    <Button
                      // variant="contained"
                      className={classes.addNewButton}
                      onClick={handleAddProductClick}
                    >
                      Add New
                    </Button>
                  </Link>
                </Grid>

                {/* {userHasRight(Privileges.GeneratePayroll) && (
                  <Grid item>
                    <Button
                      className={classes.addButtonPdfExcel}
                      onClick={handleOpenDialogGenerate}
                    >
                      Generate Payroll
                    </Button>
                  </Grid>
                )} */}
              </Grid>
            </Grid>
          </Grid>

          <Grid>
            <TableContainer>
              <Table className={classes.table}>
                <TableHead className={classes.tableHeaderRow}>
                  <TableRow>
                    <TableCell className={classes.tablheader}>
                      <strong>Name</strong>
                    </TableCell>
                    <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "center" }}
                    >
                      <strong>Schedule</strong>
                    </TableCell>
                    <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "center" }}
                    >
                      <strong>clocked Hours</strong>
                    </TableCell>
                    <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "center" }}
                    >
                      <strong>Punch In</strong>
                    </TableCell>
                    <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "center" }}
                    >
                      <strong>Punch Out</strong>
                    </TableCell>
                    {userHasRight(Privileges.ScheduleEdit) && (
                      <TableCell
                        className={classes.tablheader}
                        sx={{ textAlign: "right" }}
                      >
                        <strong>Actions</strong>
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoading || tenantIsLoading ? (
                    <TableRow>
                      <TableCell colSpan={20} align="center">
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="10vh"
                        >
                          <CircularProgress />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : isError || coursings.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={20} align="center">
                        {isError ? "Error fetching data" : "No data available"}
                      </TableCell>
                    </TableRow>
                  ) : (
                    coursings
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row: IScheduleListDetails, index) => (
                        <TableRow
                          key={index}
                          className={classes.tableRowHover}
                          // sx={{
                          //   backgroundColor:
                          //     !row.workStartTime?.punched_time &&
                          //     row.schedule?.startTime &&
                          //     dayjs(
                          //       `2000-01-01T${row.schedule?.startTime}`
                          //     ).isBefore(
                          //       dayjs(`2000-01-01T${dayjs().format("HH:mm")}`)
                          //     )
                          //       ? "#f5e5e5c4"
                          //       : "transparent",
                          // }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                          >
                            {" "}
                            <Grid container spacing={1}>
                              {/* <Grid item>
                                <Box className={classes.SelectImageTableBox}>
                                  {teamMap.get(row.empid)?.image ? (
                                    <img
                                      src={teamMap.get(row.empid)?.image}
                                      alt="Category Image"
                                      className={classes.SelectImageTable}
                                    />
                                  ) : (
                                    <Avatar
                                      alt="Travis Howard"
                                      src={AvatarImg}
                                      className={classes.SelectImageTable}
                                    />
                                  )}
                                </Box>
                              </Grid> */}
                              <Grid
                                item
                              >
                                <Link
                                  to={`/team-history/${row.empid}`}
                                  className={classes.iconLinkPropNormal}
                                >
                                  <Typography className={classes.nameTableList}>
                                    {teamMap.get(row.empid)?.name || ""}
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={faUser}
                                        style={{ color: "#1976d2" }}
                                      />
                                    </span>
                                  </Typography>
                                </Link>
                              </Grid>
                            </Grid>
                          </TableCell>
                          <TableCell
                            scope="row"
                            className={classes.tablCell}
                            sx={{ textAlign: "center" }}
                          >
                            {formatTime(row.schedule?.startTime)} -{" "}
                            {formatTime(row.schedule?.endTime)}{" "}
                            {row.schedule &&
                              row.schedule.spansNextDay == true && (
                                <span
                                  style={{
                                    color: "#e3791a",
                                    fontWeight: 600,
                                    lineHeight: 1.5,
                                    fontSize: "0.875rem",
                                    paddingLeft: "1px",
                                  }}
                                >
                                  [next day]
                                </span>
                              )}
                          </TableCell>
                          <TableCell
                            scope="row"
                            className={classes.tablCell}
                            sx={{ textAlign: "center" }}
                          >
                            {row.workStartTime?.actual_punched_time ? (
                              <>
                                {formatTime(
                                  row.workStartTime.actual_punched_time
                                )}{" "}
                                -{" "}
                                {row.finishWorkTime?.actual_punched_time
                                  ? formatTime(
                                      row.finishWorkTime.actual_punched_time
                                    )
                                  : "Pending"}
                              </>
                            ) : (
                              ""
                            )}
                          </TableCell>
                          <TableCell
                            scope="row"
                            className={classes.tablCell}
                            sx={{ textAlign: "center" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent={"center"}
                            >
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Box
                                  // className={
                                  //   row.isStartWork === false
                                  //     ? classes.editButtonStatusWaiting
                                  //     : classes.editButtonStatusAvailable
                                  // }
                                  sx={{
                                    cursor: row.workStartTime?.punched_time
                                      ? "pointer"
                                      : "default",
                                  }}
                                  onClick={() => {
                                    if (
                                      row.workStartTime?.punched_time &&
                                      userHasRight(Privileges.ScheduleEdit)
                                    ) {
                                      handleOpenDialogAdminEditPunchIn(
                                        row.workStartTime
                                      );
                                    }
                                  }}
                                >
                                  {userHasRight(Privileges.ScheduleEdit) &&
                                  row.workStartTime?.punched_time ? (
                                    <>
                                      <Tooltip
                                        title={
                                          <>
                                            <Typography
                                              variant="body2"
                                              key={index}
                                            >
                                              <strong>Edit </strong>
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              key={index}
                                            >
                                              <strong>Punch-in Time</strong>
                                            </Typography>
                                          </>
                                        }
                                        sx={{ fontSize: "14px" }}
                                      >
                                        <Chip
                                          sx={{
                                            cursor: row.workStartTime
                                              ?.punched_time
                                              ? "pointer"
                                              : "default",
                                          }}
                                          className={
                                            row.isStartWork === false
                                              ? classes.editChipWorkFalse
                                              : classes.editChipWorkTrue
                                          }
                                          label={
                                            <>
                                              {formatTime(
                                                row.workStartTime.punched_time
                                              ) || "Pending"}
                                              <CiEdit
                                                style={{
                                                  fontSize: 20,
                                                  marginLeft: "5px",
                                                }}
                                              />
                                            </>
                                          }
                                        />
                                      </Tooltip>
                                    </>
                                  ) : (
                                    <Chip
                                      sx={{
                                        cursor: row.workStartTime?.punched_time
                                          ? "pointer"
                                          : "default",
                                      }}
                                      className={
                                        row.isFinishWork === false
                                          ? classes.editChipWorkFalse
                                          : classes.editChipWorkTrue
                                      }
                                      label={
                                        formatTime(
                                          row.workStartTime?.punched_time
                                        ) || "Pending"
                                      }
                                    />
                                  )}
                                </Box>
                              </Grid>
                              {row.workStartTime?.punched_time &&
                                row.workStartTime?.created_by && (
                                  <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Typography>
                                      {userMap.get(
                                        row.workStartTime.created_by
                                      ) || ""}
                                    </Typography>
                                  </Grid>
                                )}
                            </Grid>
                          </TableCell>

                          <TableCell
                            scope="row"
                            className={classes.tablCell}
                            sx={{ textAlign: "center" }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent={"center"}
                            >
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Box
                                  // className={
                                  //   row.isFinishWork === false
                                  //     ? classes.editButtonStatusWaiting
                                  //     : classes.editButtonStatusAvailable
                                  // }
                                  sx={{
                                    cursor: row.finishWorkTime?.punched_time
                                      ? "pointer"
                                      : "default",
                                  }}
                                  onClick={() => {
                                    if (
                                      row.finishWorkTime?.punched_time &&
                                      userHasRight(Privileges.ScheduleEdit)
                                    ) {
                                      handleOpenDialogAdminEditPunchOut(
                                        row.finishWorkTime
                                      );
                                    }
                                  }}
                                >
                                  {userHasRight(Privileges.ScheduleEdit) &&
                                  row.finishWorkTime?.punched_time ? (
                                    <Tooltip
                                      title={
                                        <>
                                          <Typography
                                            variant="body2"
                                            key={index}
                                          >
                                            <strong>Edit </strong>
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            key={index}
                                          >
                                            <strong>Punch-out Time</strong>
                                          </Typography>
                                        </>
                                      }
                                      sx={{ fontSize: "14px" }}
                                    >
                                      <Chip
                                        sx={{
                                          cursor: row.finishWorkTime
                                            ?.punched_time
                                            ? "pointer"
                                            : "default",
                                        }}
                                        className={
                                          row.isFinishWork === false
                                            ? classes.editChipWorkFalse
                                            : classes.editChipWorkTrue
                                        }
                                        label={
                                          <>
                                            {row.workStartTime?.punched_date !==
                                            row.finishWorkTime.punched_date
                                              ? `${dayjs(
                                                  row.finishWorkTime
                                                    .punched_date
                                                ).format(
                                                  "MMM-DD, YYYY"
                                                )} ${formatTime(
                                                  row.finishWorkTime
                                                    .punched_time
                                                )}`
                                              : formatTime(
                                                  row.finishWorkTime
                                                    .punched_time
                                                ) || "Pending"}
                                            <CiEdit
                                              style={{
                                                fontSize: 20,
                                                marginLeft: "5px",
                                              }}
                                            />
                                          </>
                                        }
                                      />
                                    </Tooltip>
                                  ) : (
                                    <Chip
                                      sx={{
                                        cursor: row.finishWorkTime?.punched_time
                                          ? "pointer"
                                          : "default",
                                      }}
                                      className={
                                        row.isFinishWork === false
                                          ? classes.editChipWorkFalse
                                          : classes.editChipWorkTrue
                                      }
                                      label={
                                        formatTime(
                                          row.finishWorkTime?.punched_time
                                        ) || "Pending"
                                      }
                                    />
                                  )}
                                </Box>
                              </Grid>
                              {row.finishWorkTime?.punched_time &&
                                row.finishWorkTime?.updated_by && (
                                  <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Typography>
                                      {userMap.get(
                                        row.finishWorkTime.updated_by
                                      ) || ""}
                                    </Typography>
                                  </Grid>
                                )}
                            </Grid>
                          </TableCell>
                          {userHasRight(Privileges.ScheduleEdit) && (
                            <TableCell className={classes.tablCell}>
                              <Grid
                                container
                                spacing={1}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Grid item>
                                  <Button
                                    // variant="contained"
                                    className={classes.editButtonList}
                                    onClick={() =>
                                      handleOpenDialogAdminEdit(row)
                                    }
                                  >
                                    <EditSharpIcon
                                      className={classes.editListIcon}
                                    />
                                  </Button>
                                </Grid>
                              </Grid>
                            </TableCell>
                          )}
                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Card>
        {selectedCoursing && (
          <EmpImg
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            imgId={String(selectedCoursing.workStartTime?.id)}
          />
        )}
        {selectedImg && (
          <EmpImg
            openModel={openDialogImg}
            handleCloseDialog={handleCloseDialogImg}
            imgId={String(selectedImg?.finishWorkTime?.id)}
          />
        )}

        {selectedAdminEdit && (
          <AdminEdit
            openModel={openDialogAdminEdit}
            handleCloseDialog={handleCloseDialogAdminEdit}
            empid={Number(selectedAdminEdit.empid)}
            scheduleDate={paymentMonthYear.format("YYYY-MM-DD h:mm:ss A")}
          />
        )}

        {selectedAdminEditPunchIn && (
          <AdminPunchInEdit
            openModel={openDialogAdminEditPunchIn}
            handleCloseDialog={handleCloseDialogAdminEditPunchIn}
            id={Number(selectedAdminEditPunchIn.id)}
          />
        )}

        {selectedAdminEditPunchOut && (
          <AdminPunchOutEdit
            openModel={openDialogAdminEditPunchOut}
            handleCloseDialog={handleCloseDialogAdminEditPunchOut}
            id={Number(selectedAdminEditPunchOut.id)}
          />
        )}

        <Dialog
          open={open}
          onClose={handleCloseDialogGenerate}
          sx={{ padding: 5, minWidth: 450 }}
        >
          <Grid className={classes.Dialog}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >
                <Typography className={classes.cardTitle}>
                  Confirm Action
                </Typography>
              </Grid>
            </Grid>
            <DialogContent>
              <DialogContentText sx={{ pt: 3 }}>
                Are you sure you want to generate the payroll? This action
                cannot be undone.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                startIcon={<CloseIcon />}
                className={classes.addButton}
                onClick={handleCloseDialogGenerate}
              >
                Cancel
              </Button>
              <Box m={0.5}></Box>

              <Button
                onClick={handleConfirm}
                variant="contained"
                startIcon={<CheckCircleOutlineIcon />}
                className={classes.addButton}
              >
                Confirm
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
      </Grid>
    </Grid>
  );
};

export default Index;
